import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  openDrawer() {
    const event = new CustomEvent("drawer:open", {
      bubbles: true,
      detail: { url: this.element.dataset.urlValue }
    })
    document.dispatchEvent(event)
  }
}
